import commonStyles from '../../../../styles/commonStyles';
import Colors from '../../../../styles/colors';

const soundcast = {
  multipleInputWrapper: {
    padding: '0 0 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  multipleInputLeft: {
    fontSize: '1.6rem',
    fontWeight: 600,
    padding: '10px 15px',
    background: '#eee',
    border: '1px solid #e5e5e5',
    borderRight: 'none',
    width: 50,
    textAlign: 'center',
    borderRadius: 4,
  },
  multipleInputCenter: {
    width: ' 100%',
    fontSize: '1.6rem',
    marginBottom: 0,
    padding: 10,
    fontWeight: 500,
    borderRadius: 4,
    minWidth: 0,
  },
  multipleInputRight: {
    fontSize: '1.6rem',
    fontWeight: 600,
    padding: '10px 15px',
    background: '#eee',
    border: '1px solid #e5e5e5',
    borderLeft: 'none',
    borderRadius: 4,
  },
  addFeature: {
    fontSize: 20,
    marginLeft: 10,
    color: Colors.link,
    cursor: 'pointer',
  },
  addFeatureButton: {
    marginTop: 10,
    backgroundColor: '#61e1fb',
    padding: '10px 20px',
    border: 0,
    color: Colors.mainWhite,
    fontSize: '1.6rem',
    borderRadius: 4,
    cursor: 'pointer',
  },
  featuresInfoWrapper: {
    backgroundColor: '#fff',
    padding: '10px 20px 20px',
  },
  featuresInfoInputDivision: {
    padding: '10px 0',
  },
  hostInfoWrapper: {
    backgroundColor: '#fff',
    padding: '10px 20px 20px',
  },
  hostInfoInputDivision: {
    padding: '10px 0',
  },
  hostInfoDivider: {
    padding: 10,
    background: '#e8e8e8',
    textAlign: 'center',
    fontSize: '1.8rem',
  },
  hostAddButton: {
    marginTop: 10,
    borderRadius: 3,
  },
  introOutroWrapper: {
    background: Colors.mainWhite,
  },
  introOutroHeadText: {
    padding: '20px 20px 0',
    display: 'block',
    fontSize: '1.8rem',
    fontWeight: 600,
  },
  introOutroSaved: {
    padding: 20,
    background: '#f1f0f0',
    fontSize: '1.6rem',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 95,
  },
  introOutroSavedTxt: {
    color: '#009688',
    fontWeight: 600,
  },
  introOutroRemove: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
  },
};

const episode = {
  topHeaderSwitcher: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toggleWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  modal: {
    background: 'rgba(0, 0, 0, 0.7)',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    position: 'fixed',
    zIndex: 9999,
  },
  modalContent: {
    transform: 'translate(-50%)',
    backgroundColor: 'white',
    top: '40%',
    left: '50%',
    position: 'absolute',
    width: 720,
    zIndex: 103,
    borderRadius: 5,
  },
  audioProcessingHorizontalLine: {
    border: '0.4px solid lightgray',
  },
  audioProcessingOverlapOption: {
    width: 60,
    marginBottom: 0,
    height: 30,
    fontSize: '1.5rem',
    borderRadius: 15,
    boxSizing: 'border-box',
  },
  toggleOptionsMargin: {
    marginTop: 15
  },
  toggleWithValueInputLabel: {
    fontWeight: 800
  },
  toggleWithValueInputUnits: {
    paddingLeft: 10,
    fontSize: 14
  },
  toggleOptionsContent: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: 15,
  },
  optionToggleWrapper: {
    marginLeft: '0.5em',
  },
  optionToggleMainText: {
    fontSize: '1.6rem',
    fontWeight: 800,
  },
  optionToggleSubText: {
    fontSize: '1.3rem',
    fontWeight: 'normal',
  },
  actionsInput: {
    height: 100,
    minHeight: 100,
    fontSize: '1.6rem',
    borderRadius: 5,
    resize: 'vertical',
    overflow: 'auto',
    marginBottom: -6,
  },
  optionalImportWrapper: {
    margin: '0 auto',
    width: '100%',
    textAlign: 'center',
    paddingBottom: 10,
  },
  importOrOption: {
    padding: '0px 10px 10px',
  },
  notesLabel: {
    fontSize: '1.6rem',
    padding: '10px 0px',
  },
  playbackWrapper: {
    background: Colors.mainWhite,
    borderRadius: '10px 10px 0 0',
  },
  playbackInnerWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  playbackDivision: {
    margin: 5,
  },
  playbackHeadText: {
    paddingBottom: 20,
    display: 'block',
    fontSize: '1.8rem',
    fontWeight: 600,
  },
  miniPlayBackBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1rem',
  },
  playbackTimer: {
    fontSize: '1.6rem',
    fontWeight: 500,
  },
};

const common = {
  rowDivision: {
    padding: '10px 0',
  },
  topHeaderWrapper: {
    padding: '20px 20px 0',
  },
  inputTitle: { ...commonStyles.inputTitle, fontSize: '1.6rem' },
  inputTitleWrapper: {
    padding: '10px 0',
  },
  inputLabelWrapper: {
    fontSize: '1.6rem',
    fontWeight: 700,
    margin: '0 0 10px',
  },
  inputLabelRequire: {
    fontSize: '1.6rem',
    color: '#F44336',
  },
  statusLink: {
    margin: '0 12px',
  },
  hostImage: { ...commonStyles.hostImage },
  inputFileHidden: { ...commonStyles.inputFileHidden },
  coverArtUploader: {
    width: 260,
  },
  coverArt: {
    width: 260,
    height: 260,
    borderRadius: 10,
    overflow: 'hidden',
    position: 'relative',
    border: '1px solid #c3c3c3',
  },
  requiredTxt: {
    color: Colors.red,
  },
  errorTxt: {
    color: Colors.red,
  },
  plainWhiteWrapper: {
    backgroundColor: Colors.mainWhite,
    padding: '10px 20px',
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
  },
  cancelImg: { ...commonStyles.cancelImg },
  dropdownWrapper: {
    width: '100%',
    padding: 0,
    border: '1px solid #dfdfdf',
    borderRadius: 5,
    backgroundColor: '#fff',
  },
  dropdownTitle: {
    padding: 10,
    fontSize: '1.6rem',
  },
  dropdownCaret: {
    position: 'absolute',
    right: 10,
    top: '50%',
  },
  dropdownButton: {
    width: 370,
    padding: '10px',
    backgroundColor: '#fff',
    border: '1px solid #dfdfdf',
    borderBottom: 'none',
    boxSizing: 'border-box',
  },
  miniHeaderText: {
    fontSize: 18,
    color: Colors.black,
    fontWeight: 800,
    paddingTop: 10,
    paddingBottom: 10,
  },
  miniSubheaderText: {
    fontWeight: 'normal',
    fontSize: '1.4rem',
    verticalAlign: 'bottom',
  },
  loaderWrapper: {
    ...commonStyles.loaderWrapper,
    width: 'calc(100% - 133px)',
    float: 'left',
  },
  toggleStatus: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  toggleStatusLabel: {
    fontSize: 16,
    fontWeight: 800,
    marginLeft: '0.5em',
    width: '100%',
  },
  inputDescription: {
    ...commonStyles.inputTitle,
    height: 120,
    fontSize: '1.6rem',
  },
  inputDescriptionHelper: {
    textAlign: 'right',
    fontSize: '1.4rem',
    color: '#4f4f4f',
  },
  editorStyle: {
    padding: '0px 15px',
    fontSize: '18px',
    height: '500px',
    width: '100%',
    backgroundColor: Colors.mainWhite,
    lineHeight: '1.6em',
  },
  checkbox: {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    verticalAlign: 'middle',
    borderRadius: '1px',
    borderColor: 'black',
    borderWidth: 1,
    boxSizing: 'border-box',
    marginLeft: 10,
  },
  uploadResourceButton: {
    backgroundColor: 'rgba(7, 7, 7, 0.6)',
    width: '100%',
    height: 70,
    color: Colors.mainWhite,
    fontSize: 18,
    border: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  fileTypesLabel: {
    fontSize: 16,
    marginLeft: 0,
    display: 'block',
  },
  radioButton: {
    marginBottom: 10,
  },
  thumbSwitched: {
    backgroundColor: Colors.link,
  },
  trackSwitched: {
    backgroundColor: Colors.link,
  },
  soundcastSelectWrapper: {
    backgroundColor: Colors.mainWhite,
    padding: '10px 20px',
    borderRadius: 10,
  },
  soundcastSelect: {
    fontSize: '1.6rem',
    borderRadius: 4,
    backgroundPosition: 'right 5px bottom 6px',
  },
  couponButton: {
    fontSize: '1.4rem',
    color: Colors.mainOrange,
    cursor: 'pointer',
    padding: '10px 15px',
    margin: '2px 0',
    border: `1px dashed ${Colors.mainOrange}`,
    display: 'inline-block',
  },
  podcastRssFeed: {
    background: '#fff',
    padding: 20,
    borderRadius: 5,
    marginBottom: 10,
  },
  podcastTitleText: {
    fontSize: '1.6rem',
    fontWeight: 600,
    paddingBottom: 0,
    margin: 0,
  },
  proTextTag: {
    color: Colors.link,
    fontWeight: 700,
    fontSize: '1.4rem',
    display: 'inline-block',
  },
  actionButtonWrapper: {
    position: 'fixed',
    top: '15rem',
    right: 0,
    width: 270,
  },
  draftButton: {
    backgroundColor: Colors.link,
    color: Colors.fontBlack,
    fontSize: 16,
    width: '160px',
    height: '40px',
    lineHeight: '40px',
    borderRadius: 10,
    marginTop: 30,
    marginRight: 'auto',
    marginBottom: 0,
    marginLeft: 'auto',
    // textAlign: 'center',
    paddingTop: 5,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  publishButton: {
    backgroundColor: Colors.mainOrange,
    color: Colors.mainWhite,
  },
  uploadButton: {
    backgroundColor: Colors.link,
    // width: 80,
    height: 35,
    // float: 'left',
    color: Colors.mainWhite,
    fontSize: 16,
    border: 0,
    marginTop: 5,
  },
  statusProcess: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4rem',
  },
};

const Styles = {
  ...soundcast,
  ...episode,
  ...common
};

export default Styles;
